/**
 * The look of a field on the sign-in screens.
 *
 * One function rather than the same string in three places: the two screens
 * between them draw an email box, a password box and six digit boxes, and a
 * border colour that drifts between them is the kind of thing nobody notices
 * until the screens are side by side in a screenshot.
 *
 * Taken from the dietitian app's auth screens unchanged — `#DCE0E4` at rest
 * and the brand teal on focus — so both products' sign-in pages are recognisably
 * the same page.
 */
export const authFieldClasses = (invalid: boolean): string =>
  `w-full px-4 py-3.5 bg-white border rounded-lg text-[15px] text-ink placeholder-[#9AA4AE] focus:outline-none transition-colors ${
    invalid ? "border-[#D14343]" : "border-[#DCE0E4] focus:border-[#00C2CB]"
  }`;

/** The error line under a field. Same size and colour wherever it appears. */
export const AUTH_ERROR_CLASSES = "mt-1.5 text-xs text-[#D14343]";
